var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import "@frameworks/salesjourney/stylesheets/components/HOC/LayoutHOC/LayoutHOC.scss";
import TransparentHeader from "@frameworks/salesjourney/components/Generic/TransparentHeader/TransparentHeader";
var LayoutHOC = function (props) {
    var _a = __read(React.useState(React.createElement(React.Fragment, null)), 2), headerLeftComponent = _a[0], setHeaderLeftComponent = _a[1];
    return (React.createElement("div", { className: "primary-layout-hoc-container d-flex flex-column" },
        React.createElement("div", { className: "gradient-circle" }),
        React.createElement(TransparentHeader, { leftSideComponent: headerLeftComponent, logoutUser: props === null || props === void 0 ? void 0 : props.logoutUser, redirectToLoginPage: props === null || props === void 0 ? void 0 : props.redirectToLoginPage }),
        React.createElement("div", { className: "child-component-container ".concat(props.parentClassName ? props.parentClassName : "") },
            React.createElement(props.component, __assign({}, props, { setHeaderLeftComponent: setHeaderLeftComponent })))));
};
export default LayoutHOC;
